import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const ScrollContainer = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const SourcesGrid = styled.div`
  display: flex;
  gap: 1rem;
  padding: 0.5rem 0;
`;

export const SourceItem = styled.div`
  flex: 0 0 285px;
  min-width: 285px;
`;

export const ArrowButton = styled.button`
  position: absolute;
  bottom: calc(50% - 16px);
  z-index: 1;
  background: ${({ theme }) => theme.color.chatPanelBG};
  border: 1px solid ${({ theme }) => theme.color.chatBorder};
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    opacity: 0.8;
  }
`;

export const LeftArrowButton = styled(ArrowButton)`
  left: 0;
`;

export const RightArrowButton = styled(ArrowButton)`
  right: 0;
`;

export const ArrowIcon = styled.svg`
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.color.chatHeading};
`;

